module.exports = __webpack_public_path__ + "static/wuxing_logo-16b6c2422d067afc9c894fca6beec87a.svg";